<div class="page-header">
  <h1>DocuSign Sign Failed</h1>
  <div class="instructions">
    <div class="subtitle">{{destinationEmail}} failure signing Document({{envelopeId}}) signed successfully.</div>
  </div>
</div>